import React from 'react';
import { createRoot } from 'react-dom/client';
import { initRelatedTagsRenderer } from '@core/ts/components/related-tags/RelatedTagsRenderer';
import getRelatedTagsView from '@hooks/relatedTagsView';
import { readCategoryArticlesBootstrap } from '@core/ts/components/category-articles/categoryArticlesBootstrap';
import { CategoryArticlesIsland } from '@core/ts/components/category-articles/CategoryArticlesIsland';
/**
 * Metalcutting override for CATEGORY page hook.
 *
 * Uses the core CategoryArticlesIsland for orchestration (data loading, URL sync, load more)
 * and the metalcutting-specific categoryArticlesView (with MC CSS classes) for presentation.
 *
 * Related tags are initialised via initRelatedTagsRenderer before mounting the island.
 */
export default async function onCategory(_context) {
    // 1. Initialise related-tags renderer (required for tagsContract in cards)
    const tagsContract = getRelatedTagsView();
    await initRelatedTagsRenderer(tagsContract);
    // 2. Load bootstrap data and mount the core island
    const bootstrap = readCategoryArticlesBootstrap();
    if (!bootstrap)
        return;
    const container = document.getElementById('category-articles-root');
    if (!container)
        return;
    const root = createRoot(container);
    root.render(React.createElement(CategoryArticlesIsland, { bootstrap }));
}
